import {Component, Input} from '@angular/core';
import {NgClass} from '@angular/common';
import {SafeHtml} from '@angular/platform-browser';

@Component({
  selector: 'app-card-campana-component',
  standalone: true,
  imports: [
    NgClass
  ],
  templateUrl: './card-campana-component.html',
  styleUrl: './card-campana-component.scss',
})
export class CardCampanaComponent {
  @Input() titulo: string = '';
  @Input() subtitulo: string = '';
  @Input() icon: SafeHtml | string = '';
  @Input() colorIcon: string = '';
}
